import Tr from 'translations/Translations';

export const DemandValidation = {
    //part1
    DEMAND: "DEMAND",
    COMMISSION: "COMMISSION",
    QUESTIONNAIRE: "QUESTIONNAIRE",
    DEALINGS: "DEALINGS",
    SCHEDULE: "SCHEDULE",
    SIWZ: "SIWZ",
    PUBLICATION: "PUBLICATION",
    EX_POST_GO_TO_FINISH: "EX_POST_GO_TO_FINISH",
    ESPD: "ESPD",
    NOTICE: "NOTICE",
    NATIONAL_NOTICE: "NATIONAL_NOTICE",
    CONTRACTOR: "CONTRACTOR",
    GUARANTEE: "GUARANTEE",
    PREPARING_PAPERS_GENERATOR: "PREPARING_PAPERS_GENERATOR",
    PREPARING_ADDITIONAL_INFO: "PREPARING_ADDITIONAL_INFO",
    APPROVAL: "APPROVAL",
    ENOTICES2: "ENOTICES2",
    //part3
    PART_3_SECTION: "PART_3_SECTION",
    OFFERS: "OFFERS",
    DOCUMENTS: "DOCUMENTS",
    CONTRACTOR_VERIFICATION: "CONTRACTOR_VERIFICATION",
    OFFERS_EVALUATION: "OFFERS_EVALUATION",
    OFFER_CHOICE: "OFFER_CHOICE",
    OFFER_CHOICE_APPROVAL: "OFFER_CHOICE_APPROVAL",
    PRIMARY_TENDER_CHOICE: "PRIMARY_TENDER_CHOICE",
    ADDITIONAL_ROUND_PASSIVE: "ADDITIONAL_ROUND_PASSIVE",
    OFFERS_CHOICE_RESULT: "OFFERS_CHOICE_RESULT",
    EVALUATION_FINISH: "EVALUATION_FINISH",
    STAGE_FINISH: "STAGE_FINISH",
    PAPERS_GENERATOR: "PAPERS_GENERATOR",
    AGREEMENTS: "AGREEMENTS",
    EVALUATION_ADDITIONAL_INFO: "EVALUATION_ADDITIONAL_INFO",
    //part 4
    RESULT_NOTICE: "RESULT_NOTICE",
    FINISH_DOCUMENTS: "FINISH_DOCUMENTS",
    DEMAND_PLAN_REALIZATION: "DEMAND_PLAN_REALIZATION",
    FINISH_DEMAND: "FINISH_DEMAND",
    ARCHIVING: "ARCHIVING",
    FINISH_ADDITIONAL_INFO: "FINISH_ADDITIONAL_INFO",
}

export const DemandValidationKeys = {
    //part1
    DEMAND: 'mp_1_demand',
    COMMISSION: 'mp_1_commission',
    QUESTIONNAIRE: 'mp_1_questionnaire',
    DEALINGS: 'mp_1_dealings',
    SCHEDULE: 'mp_1_schedule',
    SIWZ: 'mp_1_siwz',
    PUBLICATION: 'mp_1_publication',
    EX_POST_GO_TO_FINISH: 'mp_1_ex_post_go_to_finish',
    ESPD: 'mp_1_espd',
    NOTICE: 'mp_1_notice',
    NATIONAL_NOTICE: 'mp_1_national_notice',
    CONTRACTOR: 'mp_1_contractor',
    GUARANTEE: 'mp_1_guarantee',
    PREPARING_PAPERS_GENERATOR: 'mp_1_preparing_papers_generator',
    PREPARING_ADDITIONAL_INFO: 'mp_1_preparing_additional_info',
    APPROVAL: 'mp_1_approval',
    ENOTICES2: 'mp_1_enotices2',
    //part3
    OFFERS: 'mp_3_offers',
    DOCUMENTS: 'mp_3_documents',
    CONTRACTOR_VERIFICATION: 'mp_3_contractor_verification',
    OFFERS_EVALUATION: 'mp_3_offers_evaluation',
    OFFER_CHOICE: 'mp_3_offer_choice',
    OFFER_CHOICE_APPROVAL: "mp_3_offer_choice_approval",
    PRIMARY_TENDER_CHOICE: 'mp_3_primary_tender_choice',
    ADDITIONAL_ROUND_PASSIVE: 'mp_3_additional_round_passive',
    OFFERS_CHOICE_RESULT: 'mp_3_offers_choice_result',
    EVALUATION_FINISH: 'mp_3_evaluation_finish',
    STAGE_FINISH: 'mp_3_stage_finish',
    PAPERS_GENERATOR: 'mp_3_papers_generator',
    AGREEMENTS: 'mp_3_agreements',
    EVALUATION_ADDITIONAL_INFO: 'mp_3_evaluation_additional_info',
    //part 4
    RESULT_NOTICE: 'mp_4_result_notice',
    FINISH_DOCUMENTS: 'mp_4_finish_documents',
    DEMAND_PLAN_REALIZATION: 'mp_4_demand_plan_realization',
    FINISH_DEMAND: 'mp_4_finish_demand',
    ARCHIVING: 'mp_4_archiving',
    FINISH_ADDITIONAL_INFO: "mp_4_finish_additional_info",
}

export const DemandValidationTr = Object.keys(DemandValidationKeys).reduce((prev, key) => {
    return {...prev, [key]: Tr(DemandValidationKeys[key])}
}, {});
